import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {RESERVATION_USERS_CARD_MODEL} from "../Requested/Model/Models";
import CustomCard from "../../../../components/CustomCard";
import CustomTooltip from "../../../../components/CustomTooltip";
import {IconInfoCard} from "../../../../components/buttons/IconButtons";
import ButtonSubAction from "../../../../components/buttons/ButtonSubAction";
import PieWhiteListEmpty from "./PieWhiteListEmpty";
import PieWhiteListFill from "./PieWhiteListFill";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 */

const ReservationUsersResume = ({
    setUserClassificationSelected,
    setShowManagerUserListModal
}) => {
    const {t} = useTranslation();
    const { getUserReservationSummary, countEventWhiteList } = useSelector((state) => state?.EmployeeEventsSlice);
    const [invitationStatus, setInvitationStatus] = useState({...RESERVATION_USERS_CARD_MODEL});
    const summary = invitationStatus.SUMMARY.list;

    /**
     * Synchronizes local invitation status state with Redux summary data.
     *
     * When `getUserReservationSummary` updates, this effect:
     * - Iterates through the base model
     * - Injects updated totals per classification
     * - Keeps UI cards in sync with backend data
     */
    useEffect(() => {
        setInvitationStatus((prev) => {
            return Object.fromEntries(
                Object.entries(prev).map(([key, value]) => {
                    return [
                        key,
                        {
                            ...value,
                            list: value.list.map((item) => ({
                                ...item,
                                total:
                                    getUserReservationSummary?.[item.prop] || 0
                            }))
                        }
                    ];
                })
            );
        });
    }, [getUserReservationSummary]);


    return (
        <div className={"mt-3"}>
            {
                Object.entries(invitationStatus).map(([key, item]) => {
                     return <div className={"mb-3"}>
                         <div className={`${item.classCard} card-border-8px p-2`}>
                             <div className={"row"}>
                                 { item.list.map((x, index) => {
                                     return <div className={`${x.cols} p-1`}>
                                         <CustomCard classCard={`${x.classCard} card-border-8px position-relative`} classContent={"p-0"}>
                                             <div className={"position-absolute t-negative-4px r-3px"}>
                                                 <CustomTooltip
                                                     text={<>
                                                         <p className={"ibl-font-w-600 fs-12px"}>{t(x.titleTrans)}</p>
                                                         <ButtonSubAction
                                                             id={`btn_rur_more_details_${index}`}
                                                             name="click_here_to_view_more_details"
                                                             onClick={() => {
                                                                 setShowManagerUserListModal(true);
                                                                 setUserClassificationSelected(x);
                                                             }}
                                                             className='btn-transparent font-color-general-00 px-0 mx-0'
                                                         />
                                                     </>}
                                                     placement={"top"}
                                                 >
                                                     <IconInfoCard className={x?.infoColor + " w-h-14px"}/>
                                                 </CustomTooltip>
                                             </div>
                                             <div className={"text-center"}>
                                                 <x.Icon className={`${x?.infoColor}`} />
                                             </div>
                                             <div className={"text-center"}>
                                                 <p className={`${x.fontColor} ibl-font-w-700 fs-24px`}>{x.total}</p>
                                             </div>
                                         </CustomCard>
                                     </div>
                                 })}
                             </div>
                         </div>
                     </div>
                })
            }
            { countEventWhiteList > 0 ?
               <PieWhiteListFill summary={summary} countEventWhiteList={countEventWhiteList}/>
               :
               <PieWhiteListEmpty summary={summary}/>
            }
        </div>
    );
};

export default ReservationUsersResume;
